<template>
<div class="chapter">
<div class="inner_page">
<section class="level1 hidden" data-number="1" epub:type="epigraph" id="epigraph">
<h1 class="hidden" data-number="1" epub:type="epigraph">Epigraph</h1>
<blockquote class="hanging_indent">
<p>Jack the lad Horner,</p>
<p>Crouched in his corner</p>
<p>Fingering a Christmas pie</p>
<p>Stuck in a thumb,</p>
<p>Pulled out a plum</p>
<p>And said ‘Clever boy am I!’</p>
</blockquote>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?7dbcee48